import FeatureToggleService from '@/utils/feature-toggle-service';
import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';
import { SET_FEATURE_FLAGS } from './mutations';

const buildFeatureFlagsActionObject = (action) => StoreModuleService.buildActionObject(MODULE_NAME, action);

// actions declarations
export const getAllFeatureFlags = buildFeatureFlagsActionObject('getAllFeatureFlags');

const actions = {
	...StoreModuleService.createDefaultActions(),
	[getAllFeatureFlags.action]({ commit }) {
		const flags = FeatureToggleService.getAllFlags();
		commit(SET_FEATURE_FLAGS, flags);
	},
};

export default actions;
